import type {JourneyProgressStatus} from "~/components/journeyProgressCard/types";
import {OttopilotEventContainerStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainer";

/** True when activity belongs to a non-active journey (archived / inactive lifecycle). */
export function resolveActivityLogCardIsInactiveFromEventContainerStatus(
    status: OttopilotEventContainerStatus,
): boolean {
    return status !== OttopilotEventContainerStatus.active;
}

export function resolveActivityLogCardIsInactiveFromLifecycleStatus(
    status: JourneyProgressStatus,
): boolean {
    return status === "inactive";
}
